import ChartTab from "./ChartTab";
import React from "react";
import _ from "lodash-es";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

const FIXED0 = value => {
  return Number.parseFloat(Number.parseFloat(value).toFixed(0));
};

class ChartClientPerformanceTabPure extends React.Component {
  render() {
    const { data } = this.props;

    let pivots = ["client", "family", "project"]; //, "project"];
    let showColumns = [
      "client",
      "family",
      "project",
      // "vendeur",
      "period1",
      "period2",
      "amountPerfVariation",
      "amountPerfVariationPourcent"
    ];

    if (
      this.props.showProductColumn === undefined ||
      this.props.showProductColumn === true
    ) {
      //show product by default
      pivots.push("product");
      showColumns.push("product");
    }

    if (!!data) {
      for (let line of data) {
        line.amountVariation =
          // FIXED0
          line.p2Amount - line.p1Amount;

        if (line.amountVariation !== 0) {
          // console.log("Line=", line);

          line.amountVariationPourcent = line.p1Amount
            ? // _.round(
              (line.amountVariation / line.p1Amount) * 100.0 //, 1)
            : 100.0;
        } else line.amountVariationPourcent = 0.0;
      }
    }

    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "client")}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={false}
        showExtra={false}
        showFilter={false}
        defaultSorted={[
          {
            id: "client",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartClientPerformanceTabPure;
